import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/elpriser/se2")({
  head: () => seoHead("/elpriser/se2"),
  beforeLoad: () => permanentRedirect("/elpriser/elomrade-2"),
});
